import MISSION_ROLE_STATES from "constants/missionRoleStates";

const ROLES = {
  developer: "developer",
  tech_lead: "tech_lead",
  squad_lead: "squad_lead",
  business_analyst: "business_analyst",
  designer: "designer",
  qa: "qa",
};

const ROLE_STATES_LABELS = {
  [MISSION_ROLE_STATES.draft]: "Requested",
  [MISSION_ROLE_STATES.published]: "Published",
  [MISSION_ROLE_STATES.unpublished]: "Unpublished",
  [MISSION_ROLE_STATES.unpublishedNew]: "Unpublished (New)",
  [MISSION_ROLE_STATES.draftInProgress]: "Draft",
  [MISSION_ROLE_STATES.closed]: "Closed",
};

const ROLE_STATES_OPTIONS = Object.values(MISSION_ROLE_STATES).map((value) => ({
  name: ROLE_STATES_LABELS[value],
  value, // e.g. "DRAFT", "UNPUBLISHED_NEW"
}));

const ROLE_ATS_REPORT_MODES = {
  all_time: "ALL_TIME",
  last_week: "LAST_WEEK",
};

const ROLES_TEMPLATE_VARIABLES = [
  {
    key: "start_date",
    label: "Start Date",
    description: "Members will see the role's start date during the application process",
  },
  {
    key: "name",
    label: "Role Name",
    description: "Members will see the role's name during the application process",
  },
  {
    key: "engagement_type",
    label: "Engagement Type",
    description: "Members will see the role's engagement type during the application process",
  },
  {
    key: "engagement_hours",
    label: "Engagement Hours",
    description: "Members will see the role's engagement hours during the application process",
  },
  {
    key: "archetype",
    label: "Archetype",
    description: "Members will see the role's archetype during the application process",
  },
  {
    key: "time_zone",
    label: "Time Zone",
    description: "Members will see the role's time zone during the application process",
  },
  {
    key: "target_rate",
    label: "Target Rate",
    description: "Members will see the role's target rate during the application process",
  },
];

export { ROLE_STATES_OPTIONS, ROLE_STATES_LABELS, ROLE_ATS_REPORT_MODES, ROLES_TEMPLATE_VARIABLES };

export default ROLES;
